import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="#EDB326"
      d="M14.164 5a.75.75 0 0 0-1.5 0v.664H12a.75.75 0 0 0 0 1.5h.664v.664a.75.75 0 0 0 1.5 0v-.664h.664a.75.75 0 0 0 0-1.5h-.664zM19.829 7.25a.75.75 0 0 1 .75.75v1.078h1.078a.75.75 0 0 1 0 1.5h-1.079v1.079a.75.75 0 1 1-1.5 0v-1.079H18a.75.75 0 0 1 0-1.5h1.078V8a.75.75 0 0 1 .75-.75"
    />
    <path
      fill="#EDB326"
      d="M18.965 14.874c.382-.066.725.28.586.643A8.558 8.558 0 1 1 8.48 4.466c.362-.14.709.202.643.585Q9.002 5.757 9 6.5a8.5 8.5 0 0 0 9.965 8.373"
    />
  </>
);

const Weather31Colored = Icon('weather-31-colored', svgContents);

export default Weather31Colored;
